import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
    BackButton,
    COLORS,
    ComponentL,
    ComponentXXS,
    PageWidth,
    Size,
    SystemIcons,
} from '@laerdal/life-react-components';
import { selectMarket, buildMarketPath } from '../../store/slices/globalConfigSlice';
import { useNavigate, useSearchParams } from 'react-router-dom';
import posthog from 'posthog-js';

const Container = styled.div`
    display: flex;
    padding: 32px;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    align-self: stretch;

    border-radius: 8px;
    background: #FFF;

`;

const IconContainer = styled.div`
    display: flex;
    width: 64px;
    height: 64px;
    justify-content: center;
    align-items: center;
    gap: 8px;

    border-radius: 64px;
    border: 2px solid ${COLORS.positive_500};
`;
const PageContainer = styled.div`
  padding: 24px 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap:8px;
`;


const QcprSupportSuggestionsCreatedPage = () => {
    const currentMarket = useSelector(selectMarket);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const caseNumber = searchParams.get('caseNumber') || '';

    const { t } = useTranslation(['translation', 'qcprSupport']);

    useEffect(() => {
        // Track successful case creation page visit
        posthog.capture('SUPP-QcprSupport-SuggestionsCreatedPageVisit', {
            page: 'QcprSupportSuggestionsCreated',
            case_number: caseNumber,
            market: currentMarket
        });
    }, [caseNumber, currentMarket]);

    const handleBackClick = () => {
        posthog.capture('SUPP-QcprSupport-SuggestionsCreatedBackClicked', {
            page: 'QcprSupportSuggestionsCreated',
            case_number: caseNumber,
            market: currentMarket
        });
        navigate(buildMarketPath(currentMarket, '/qcpr-support'));
    };

    return (
        <>

            <PageWidth $useMaxWidth={true} $maxWidth={1024}>
                <PageContainer>
                    <BackButton onClick={handleBackClick} size={Size.Small} >
                        {t('Back', { ns: 'qcprSupport' })}
                    </BackButton>

                    <Container>
                        <IconContainer>
                            <SystemIcons.CheckMark size='32px' color={COLORS.positive_500} />
                        </IconContainer>
                        <ComponentL>
                            {t("Thank you for contacting us", { ns: 'qcprSupport' })}
                        </ComponentL>
                        <ComponentXXS>
                            {t("Case number: {{caseNumber}}", { ns: 'qcprSupport', caseNumber })}
                        </ComponentXXS>
                        <ComponentXXS>
                            {t("Your case has been created and our team will review it shortly.", { ns: 'qcprSupport' })}
                        </ComponentXXS>
                    </Container>
                </PageContainer>
            </PageWidth>
        </>
    );
};

export default QcprSupportSuggestionsCreatedPage;
